module.exports = __webpack_public_path__ + "media/entities/2204-a45a0734.png";